import * as React from 'react';
import { Grid, Breadcrumbs } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Rightarrow } from '@/icons/Rightarrow';
import { BreadcrumbData } from '@/utils/breadcrumb';

interface BreadcrumbProps {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  separableicon?: React.ReactNode;
  maxItems?: number;
  separator?: any;
  sx?: any;
  fontSize?: number;
  fontWeight?: number;
  breaddata?: any;
  md?: any;
  isSmallScreen?: any;
  separaterStyles?: any;
}

const Breadcrumb=({
  startIcon,
  fontSize = 14,
  fontWeight = 0,
  separator = '>',
  sx,
  endIcon,
  separableicon,
  md,
  isSmallScreen,
  separaterStyles,
  ...other
}: BreadcrumbProps)=> {
  const location = useLocation();
  const navigate = useNavigate();

  const data: any = [];
  const list = location.pathname.split('/');
  list.shift();
  if(list?.length>1){
    list.shift();
  }
  BreadcrumbData.map((item: any) => {
    list.map((childItem: any) => {
      if (childItem === item.url.split('/')[1]) {
        data.push({ key: item.label, url: item.url });
      }
    });
  });

  const handleClick = (path: string) => {
    navigate(`${path === "/dashboard" ? '/dashboard' : '/dashboard'+path}`);
  }

  return (
    <div role="presentation">
      <Breadcrumbs
        role="presentation"
        separator={separableicon ? <Rightarrow /> : separator}
        aria-label="breadcrumb"
        sx={{
          svg: {
            marginLeft: isSmallScreen ? '16px' : '32px',
            marginRight: isSmallScreen ? '16px' : '32px'
          },
          ...separaterStyles
        }}
        {...other}
      >
        {data?.map((item: any, index: any) => {
          return (
            <Grid
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: data.length !== index + 1 ? 'pointer' : '',
                pointerEvents: data.length !== index + 1 ? 'all' : 'none',
                padding: isSmallScreen ? '4px 8px' : '8px 16px',
                borderRadius: '8px',
                '&:hover': {
                  boxShadow:
                    data.length !== index + 1 ? '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px -4px 8px 0px rgba(0, 0, 0, 0.05)' : ''
                },
                ...sx
              }}
              color={data.length === index + 1 ? '#242424' : '#737373'}
              fontWeight={700}
              fontSize={isSmallScreen ? '16px' : '20px'}
              onClick={() => handleClick(item.url)}
              fontFamily={'Poppins'}
              className={data.length === index + 1 ? 'last-crumb' : '#737373'}
            >
              {startIcon && item.startIcon}
              {item?.key && item?.key}
              {endIcon && item.startIcon}
            </Grid>
          );
        })}
      </Breadcrumbs>
    </div>
  );
}
export default Breadcrumb